import type { IPluginDisplayCondition } from '@beefree.io/sdk/dist/types/bee';
import type { Team } from '@keyvue/one-api-client';
import { Gender } from '@keyvue/one-api-client';

export function getContactDisplayConditions() {
    return [{
        type: 'Contact',
        label: 'Contact voornaam beschikbaar',
        description: 'Wanneer voornaam van de contactpersoon beschikbaar is',
        before: '{% if contact.name.firstName is not empty %}',
        after: '{% endif %}',
    }, {
        type: 'Contact',
        label: 'Contact voornaam niet beschikbaar',
        description: 'Wanneer voornaam van de contactpersoon niet beschikbaar is',
        before: '{% if contact.name.firstName is empty %}',
        after: '{% endif %}',
    }] as IPluginDisplayCondition[];
}

export function getContactGenderDisplayConditions() {
    return Gender.options.map((gender) => {
        return {
            type: 'Contact',
            label: `Contact geslacht is ${gender.label}`,
            before: `{% if contact.gender == '${gender.value}' %}`,
            after: '{% endif %}',
        };
    }) as IPluginDisplayCondition[];
}

export function getTeamDisplayConditions(teams: Team[]) {
    return teams.map((team) => {
        return {
            type: 'Vestiging',
            label: `Vestiging is ${team.name}`,
            before: `{% if team.id == '${team.id}' %}`,
            after: '{% endif %}',
        };
    }) as IPluginDisplayCondition[];
}
